module.exports = __webpack_public_path__ + "img/thumb-les-proies-ambulantes.1e966f54.jpg";